import React from 'react';

import { AlertDialog } from '@lyearn/molecules';

function ToggleTeachModeModal({
  onClose,
  onConfirm,
  isTeachModeEnabled,
}: {
  onClose: () => void;
  onConfirm: () => void;
  isTeachModeEnabled: boolean;
}) {
  return (
    <AlertDialog
      header={{
        title: isTeachModeEnabled ? 'Exit teach mode?' : 'Enter teach mode?',
        description:
          "This action will take you to the initial chat screen. Don't worry, your current chat will be saved.",
      }}
      primaryAction={{
        appearance: 'primary',
        label: 'Toggle',
        onClick: onConfirm,
      }}
      onClose={onClose}></AlertDialog>
  );
}

export default ToggleTeachModeModal;
